import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Typography, IconButton, Button } from '@mui/material';

import FacebookIcon from '../Icon/facebook.png';
import InstagramIcon from '../Icon/instagram.png';
import YouTubeIcon from '../Icon/Youtube-Icon.png';
import TwitterIcon from '../Icon/X.png';
import LinkedInIcon from '../Icon/LinkedIn.png';

function Footer() {
  return (
    <Box
      sx={{
        background: 'linear-gradient(to right, #000000, #000000)',
        //  background:
        //   "radial-gradient(circle at top, rgba(30,144,255,0.15), transparent 40%), #000000",
        color: '#fff',
        px: 2,
        py: 6,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        mt: 'auto',
        boxShadow: '0 -3px 10px rgba(0, 0, 0, 0.2)',
        borderTop: '3px solid rgba(255, 255, 255, 0.2)',
      }}
    >
      {/* Main Sections */}
      <Box
        sx={{
          width: '100%',  
          maxWidth: 1200,
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          gap: { xs: 4, md: 6 },
        }}
      >
        {/* Quick Links */}
        <Box sx={{ minWidth: 220, textAlign: 'center' }}>
          {/* <Typography sx={styles.sectionTitle}>Quick Links</Typography> */}
          <Box sx={styles.linkBox}>
            <Link to="/" style={styles.link}>Home</Link>
            <Link to="/about-us" style={styles.link}>About Us</Link>
            <Link to="/chatbot" style={styles.link}>Vimitra</Link>
           
            {/* <Link to="/enterprise-ai-solutions" style={styles.link}>Enterprise AI</Link> */}
            <Link to="/ai-program-page" style={styles.link}>AI Immersion</Link>
            <Link to="/achievements" style={styles.link}>Achievements</Link>
          </Box>
        </Box>

        {/* Legal */}
        <Box sx={{ minWidth: 220, textAlign: 'center' }}>
          {/* <Typography sx={styles.sectionTitle}>Legal</Typography> */}
          <Box sx={styles.linkBox}>
             <Link to="/blog" style={styles.link}>Blogs</Link>
            <Link to="/terms-of-service" style={styles.link}>Terms of Service</Link>
            <Link to="/privacy-policy" style={styles.link}>Privacy Policy</Link>
            <Link to="/cookies-policy" style={styles.link}>Cookies Policy</Link>
            <Link
              to="/refunds-and-cancellations-policy"
              style={styles.link}
            >
              Refund & Cancellations
            </Link>
          </Box>
        </Box>

        {/* Join Us */}
        <Box sx={{ minWidth: 220, textAlign: 'center' }}>
          {/* <Typography sx={styles.sectionTitle}>Join Us</Typography> */}
          <Box sx={styles.linkBox}>
            <Link to="/careers" style={styles.link}>Careers</Link>
            <Link to="/community" style={styles.link}>Community</Link>
            <Link to="/contact-us" style={styles.link}>Contact Us</Link>
            <Link to="/faqs" style={styles.link}>FAQs</Link>
            <Link to="/customer-support" style={styles.link}>Help</Link>
          </Box>
        </Box>

        {/* Social + CTA */}
        <Box sx={{ minWidth: 220, textAlign: 'center' }}>
          <Typography sx={styles.sectionTitle}>Follow Us</Typography>

          <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
            <IconButton
              href="https://www.facebook.com/people/Anthrasync/61566752842183/?mibextid=qi2Omg"
              target="_blank"
              rel="noopener noreferrer"
              sx={styles.iconButton}
            >
              <img src={FacebookIcon} alt="Facebook" style={styles.icon} />
            </IconButton>

            <IconButton
              href="https://www.instagram.com/anthrasync/"
              target="_blank"
              rel="noopener noreferrer"
              sx={styles.iconButton}
            >
              <img src={InstagramIcon} alt="Instagram" style={styles.icon} />
            </IconButton>

            <IconButton
              href="https://www.youtube.com/@AnthrasyncMarketing"
              target="_blank"
              rel="noopener noreferrer"
              sx={styles.iconButton}
            >
              <img src={YouTubeIcon} alt="YouTube" style={styles.icon} />
            </IconButton>

            <IconButton
              href="https://x.com/anthrasync"
              target="_blank"
              rel="noopener noreferrer"
              sx={styles.iconButton}
            >
              <img src={TwitterIcon} alt="X" style={styles.icon} />
            </IconButton>

            <IconButton
              href="https://www.linkedin.com/company/anthrasync-solutions-private-limited/"
              target="_blank"
              rel="noopener noreferrer"
              sx={styles.iconButton}
            >
              <img src={LinkedInIcon} alt="LinkedIn" style={styles.icon} />
            </IconButton>
          </Box>

          {/* Book Appointment */}
          <Box sx={{ mt: 4 }}>
            <Button
              href="https://calendar.google.com/calendar/appointments/schedules/AcZssZ0G3d7qWB_ZTGJ8OGjjCR4VpM6YQ6nBEzJ4YpMtueSJ_l4ApI5sy80wqrknyolLr_ndgqOYlxO4?gv=true"
              target="_blank"
              rel="noopener noreferrer"
              variant="contained"
              sx={{
                backgroundColor: '#039BE5',
                color: '#fff',
                textTransform: 'none',
                fontWeight: 'bold',
                fontSize: '1rem',
                px: 4,
                py: 1.5,
                borderRadius: '25px',
                '&:hover': {
                  backgroundColor: '#0288D1',
                },
              }}
            >
              Book an Appointment
            </Button>
          </Box>
        </Box>
      </Box>

      {/* Copyright */}
      <Box sx={{ mt: 5, textAlign: 'center' }}>
        <Typography variant="body2" sx={styles.copyright}>
          © 2026 Anthrasync Inc. All rights reserved.
        </Typography>
      </Box>
    </Box>
  );
}

const styles = {
  link: {
    color: '#fff',
    textDecoration: 'none',
    margin: '5px 0',
    fontSize: '1rem',
    fontWeight: '500',
    letterSpacing: '0.5px',
    transition: 'all 0.3s ease',
  },
  linkBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  iconButton: {
    '&:hover': {
      transform: 'scale(1.1)',
      transition: 'transform 0.2s ease',
    },
  },
  icon: {
    width: 30,
    height: 30,
  },
  sectionTitle: {
    mb: 2,
    fontWeight: 'bold',
    textTransform: 'uppercase',
    letterSpacing: 3,
    color:'#ffffffee',
    fontFamily: '"Roboto", sans-serif',
    fontSize: { xs: '1.2rem', md: '1.5rem' },
  },
  copyright: {
    fontSize: { xs: '0.9rem', sm: '1rem' },
    opacity: 0.7,
    letterSpacing: 2,
    fontFamily: '"Roboto", sans-serif',
  },
};

export default Footer;
